var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n\n<li>\n  <i class="ra ra-circle legend-principal icon-space-right"></i> Principal &amp; Interest\n  <span id="principle_interest" class="float-right">'+
((__t=( mortgageData.principle_interest ))==null?'':__t)+
'</span>\n</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/principal.jst.ejs